module.exports = __webpack_public_path__ + "static/media/talleresdif003.1ebddc0d.jpeg";